import * as Backbone from "backbone";

export default class Source extends Backbone.Model {};
